import { render, staticRenderFns } from "./ListInvoice.vue?vue&type=template&id=95dd2efa&scoped=true&"
import script from "./ListInvoice.vue?vue&type=script&lang=js&"
export * from "./ListInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dd2efa",
  null
  
)

export default component.exports